module.exports = __webpack_public_path__ + "img/brand_bg.25887ead.png";